var exports = {
  "P": "xa15a2ab7--9b0df6--textarea",
};

module.exports = exports;
